export default __webpack_public_path__ + "static/media/higher_icon_clipboard.86fb5e46.svg";